import { createActionCreator } from '@pressreader/appstore';

import { IContextMenuPopup, IDialogPopup } from '../types';

const pre = '@pressreader/popups-legacy/';

interface IOpenDialogPayload {
    dialog: IDialogPopup<unknown>;
}

interface ICloseDialogRequestPayload {
    /** Dialog id */
    id: string;

    context: unknown;

    /** Whether dialog was closed manually via code and not by a user action. */
    cancelled?: boolean;
}

interface IDialogCloseDonePayload {
    id: string;
}

interface IOpenContextMenuPayload {
    menu: IContextMenuPopup<unknown>;
}

interface ICloseContextMenuRequestPayload {
    id: string;

    /** Weather contextmenu is getting closed by pressing the 'back' button. */
    back?: boolean;

    /** Weather contextmenu is getting closed manually via code an not by a user action. */
    cancelled?: boolean;
}

interface IContextMenuCloseDonePayload {
    id: string;

    /** Weather contextmenu was closed by pressing the 'back' button. */
    back?: boolean;
}

export { ICloseContextMenuRequestPayload };

export const openDialogAction = createActionCreator<IOpenDialogPayload>(`${pre}open_dialog`);
export const closeDialogRequestAction = createActionCreator<ICloseDialogRequestPayload>(`${pre}close_dialog_request`);
export const dialogCloseDone = createActionCreator<IDialogCloseDonePayload>(`${pre}dialog_close_done`);

export const openContextMenuAction = createActionCreator<IOpenContextMenuPayload>(`${pre}open_contextmenu`);
export const closeContextMenuRequestAction = createActionCreator<ICloseContextMenuRequestPayload>(`${pre}close_contextmenu_request`);
export const contextMenuCloseDone = createActionCreator<IContextMenuCloseDonePayload>(`${pre}contextmenu_close_done`);

export const LEGACY_POPUP_VISIBILITY_CHANGE_ACTIONS = Object.freeze([contextMenuCloseDone, dialogCloseDone, openContextMenuAction, openDialogAction]);
